var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverStoppage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.459,
    height: 26.409,
    viewBox: "0 0 31.459 26.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Over_stoppage_",
    "data-name": "Over stoppage ",
    d: "M246.466,268.266c.029.015-28.933,0-28.948,0-1.335.039-1.617-1.384-.976-2.322,3.069-5.262,10.99-18.041,14.066-23.315a1.666,1.666,0,0,1,2.792-.015c0,.029,10.707,18.118,13.941,23.363.814,1.254-.031,2.3-.876,2.288ZM244.558,265c-2.588-4.251-11.655-20.023-11.655-20.047a.971.971,0,0,0-1.865,0c-2.461,4.275-9.2,15.782-11.655,20.047-.734.962-.466,1.4.466,1.4.012,0,24.266.012,24.242,0,.932,0,1.2-.465.466-1.4Zm-12.588.466a4.135,4.135,0,0,1-3.73-2.8l-.466-7.459a.765.765,0,0,1,1.4,0v4.2h.466v-6.527a.762.762,0,0,1,1.4,0v5.594h.466v-6.061a.764.764,0,0,1,1.4,0v6.061h.466v-4.662a.765.765,0,0,1,1.4,0v7.459h.466v-2.331c.685-1.063,1.4,0,1.4,0l-.466,3.73c.015,0-1.4,2.8-4.2,2.8Z",
    transform: "translate(-216.213 -241.863)",
    fill: "#ff7200",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverStoppage);
export default __webpack_public_path__ + "static/media/OverStoppage.e78e088ed6482fea0f33b1c60831e767.svg";
export { ForwardRef as ReactComponent };